import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const StyledBackLink = styled(Link)`
  position: absolute !important;
  left: 80px;
  top: 51px;
  line-height: 1.5;
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: capitalize;

  color: ${COLORS.white};
  text-decoration: none;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  overflow: hidden;

  cursor: pointer;

  :hover {
    ::after {
      content: '';
      position: absolute !important;
      height: 1px;
      background: ${COLORS.white};
      width: 100%;
      left: 23px;
      top: 20px;
    }
  }

  ${DOTTED_FOCUS};

  @media (max-width: 1300px) {
    left: 33px;
  }

  @media (max-width: 1000px) {
    left: 0px;
  }
`;
